import axios from 'axios';

import { extractData } from '@/api/ApiHelpers';

import type { AverageMetricResponse, ResidualsResponse } from '@/api/ApiTypes';


const snrGet = (
	handler: (responseData: AverageMetricResponse) => void,
	errorHandler: (error: unknown) => void,
): void => {
	axios.get('/rinex/get_snr/').then(extractData(handler)).catch(errorHandler);
};


const multipathGet = (
	handler: (responseData: AverageMetricResponse) => void,
	errorHandler: (error: unknown) => void,
): void => {
	axios.get('/rinex/get_multipath/').then(extractData(handler)).catch(errorHandler);
};


const residualsGet = (
	handler: (responseData: ResidualsResponse) => void,
	errorHandler: (error: unknown) => void,
	subNetworkId: number | null,
): void => {
	axios.get('/rinex/get_residuals/', { params: { sub_network: subNetworkId } })
		.then(extractData(handler)).catch(errorHandler);
};


export default {
	snrGet,
	multipathGet,
	residualsGet,
};
